import axios from 'axios';

import { getAuthorizationHeader } from './auth_service';


export const getArticlesById = async (articleId) => {
  let res = await axios.get(process.env.REACT_APP_BACKEND_URL + 'api/articles/' + articleId, getAuthorizationHeader())

  return res.data.data;
}


export const getArticles = async () => {
  let res = await axios.get(process.env.REACT_APP_BACKEND_URL + 'api/articles', getAuthorizationHeader())

  return res.data.data;
}

export const getFaqArticles = async () => {
  let res = await axios.get(process.env.REACT_APP_BACKEND_URL + 'api/articles?filters[type]=FAQ', getAuthorizationHeader())

  return res.data.data;
}



export const searchArticles = async (searchTerm) => {
  let res = await axios.get(process.env.REACT_APP_BACKEND_URL + `api/articles?filters[$or][0][title][$containsi]=${searchTerm}&filters[$or][1][content][$containsi]=${searchTerm}`, getAuthorizationHeader())

  return res.data.data
}
